export default function NewOccupation({}) {
	return (
		<div>
			<h1 className="text-4xl">New Occupation</h1>
			<p>
				You are about to create a new occupation. This should only be done to create a concurrent role, salary
				or pension plan. <strong>This is not a change</strong> of role, salary or pension plan but an additional
				one.
				<br />
				<br />
				By creating a new occupation, you are creating a new role, salary or pension plan that will run
				concurrently with the existing ones. This means that the employee{" "}
				<strong>will have more than one</strong> role, salary or pension plan <strong>at the same time</strong>.
			</p>
		</div>
	);
}
